import { createSelector } from "reselect";
import { sectionsSelector } from "../../../sections_selector";

export const evaluationListTotalSkinSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.evaluationListTotalSkin;
  }
);
